define(function (require) {
	const Radio = require('backbone.radio');
	const ViewManager = require('civicsUtils/view_manager');
	const dashboardChannel = Radio.channel('dashboardChannel');
	const ManageSavedSearchesModalTemplate = require('./templates/t_cpv_manage_saved_searches_modal.hbs');
	const ManageSavedSearchesChildView = require('../manage_saved_searches_modal/v_itv_manage_saved_searches');

	const save_search_model = require('civicsModels/portal/saved_searches');
	const saved_searches_collection =  require('civicsCollections/portal/saved_searches_collection');

	return Marionette.CompositeView.extend({
		template: ManageSavedSearchesModalTemplate,
		tagName: 'span',
		childView: ManageSavedSearchesChildView,
		childViewContainer: '.manage-saved-searches-list',
		ui: {
			saveButton: '.save-search-btn',
			cancelButton: '.cancel-save-search-btn',
			closeButton: '.bbm-btn-close',
			backButton: '.back-btn-list-view',
			searchInput: '.saved-search input' 
		},
		events: {
			'click @ui.saveButton': 'onSaveSearch',
			'click @ui.cancelButton': 'closeSaveSearchModal',
			'click @ui.closeButton': 'closeSaveSearchModal',
		},
		childEvents: {
			'edit:search': 'onEditSearch', 
			'child:editing': 'onSavedSearchEdit', 
			'delete:item': 'onItemDeleted',
			'set:defaultSearch': 'setDefaultSearch',
			'reset:editButtons': 'onResetEditButtons', 
		},
		initialize: function (options) {	
			this.isEditing = false;
			this.config = options.config; 
			this.collection = options.collection;
			this.onResetEditButtons(); // remove editing mode on initial load
			this.listenTo(dashboardChannel, 'delete:item', this.onItemDeleted);
		},
		childViewOptions: function () {
			return {
				collection: this.collection, 
				config: this.config
			};
		},
		onSavedSearchEdit: function (childView) {
			// Loop through child views and disable/enable "Edit" buttons
			this.collection.each((model) => {
				if (model !== childView.model) {
					model.set('isEditing', false);
					model.set('disabled', true);
				}
			});
		},
		onResetEditButtons: function() {
			this.collection.each((model) => {
				model.set({
					isEditing: false, // Exit editing mode
					disabled: false   // Re-enable all edit buttons
				});
			});
		},
		onItemDeleted: function () {
			// Check if the collection is empty after the item is deleted
			this.isSavedSearchesEmpty = this.collection.length === 0;
			this.render();
		},
		closeSaveSearchModal: function () {
			if(this.modalRegion) {
				this.modalRegion.hideModal();
			} else {
				this.destroy();
			}
		},
		// Save updated search name to model
		onEditSearch: function(childView, updatedName) {
			const editedSearchModel = new save_search_model({id: childView.model.get('id')});
				editedSearchModel.set({
					"name": updatedName
				})
			
			editedSearchModel.save(null, {
				success: () => {
					dashboardChannel.trigger('saveSearches:update');
					this.render();
				},
				error: (model, response) => {
					ViewManager.errorToWindow(response, this);
				}
			});
		},			
		templateHelpers: function() {
			return {
				isEditing: this.isEditing,
				config: this.config,
				closeBtn: this.isEditing ? false : true,
				searchData: this.selectedModel ? this.selectedModel.toJSON() : {},
				isEmpty: this.isSavedSearchesEmpty
			};
		},
	});
});
